module.exports = __webpack_public_path__ + "img/vps_icon2.52b54df.png";